import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getTimeLine } from 'apis/projectProposals.api';

const useGetProjectProposalTimeLine = (id, conds) => {
  const { data, ...rest } = useQuery(['getProjectProposalTimeLine', id], () => getTimeLine(id), {
    ...conds,
  });

  const timeLine = useMemo(() => data?.data ?? [], [data]);
  return {
    data: timeLine,
    ...rest,
  };
};

export default useGetProjectProposalTimeLine;
